import React, { useState } from 'react';
import { TabBar } from 'antd-mobile';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { AppstoreOutlined, SettingOutlined, FolderOutlined, FileOutlined } from '@ant-design/icons';
import InspectionList from './components/InspectionList';
import Settings from './components/Settings';
import Login from './components/Login';
import Loading from './components/Loading';
import AuthRoute from './components/AuthRoute';
import ProjectList from './components/ProjectList';
import LogViewer from "./components/LogViewer";

const App = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  const tabs = [
    {
      key: '/inspection',
      title: 'Inspection List',
      icon: <AppstoreOutlined />,
    },
    {
      key: '/projects',
      title: 'Projects',
      icon: <FolderOutlined />,
    },
    {
      key: '/logs',
      title: 'Logs',
      icon: <FileOutlined />,
    },
    {
      key: '/settings',
      title: 'Settings',
      icon: <SettingOutlined />,
    }
  ];

  const handleTabChange = (key) => {
    setLoading(true);
    navigate(key);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0
    }}>
      {loading && <Loading />}

      {/* Main content area */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch'
      }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/inspection"
            element={
              <AuthRoute>
                <InspectionList projects={projects} setProjects={setProjects} />
              </AuthRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <AuthRoute>
                <Settings />
              </AuthRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <AuthRoute>
                <ProjectList projects={projects} setProjects={setProjects} />
              </AuthRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <AuthRoute>
                <LogViewer />
              </AuthRoute>
            }
          />
          <Route
            path="*"
            element={
              <AuthRoute>
                <InspectionList projects={projects} setProjects={setProjects} />
              </AuthRoute>
            }
          />
        </Routes>
      </div>

      {/* TabBar at the very bottom */}
      <div style={{
        borderTop: '1px solid #eee',
        backgroundColor: 'white'
      }}>
        <TabBar onChange={handleTabChange}>
          {tabs.map(item => (
            <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
          ))}
        </TabBar>
      </div>
    </div>
  );
};

export default App;